<script setup lang="ts">
const currentYear = new Date().getFullYear()
</script>

<template>
  <footer class="app-footer">
    <span>© {{ currentYear }} 叮球 DingTennis</span>
    <span class="app-footer-divider" aria-hidden="true">·</span>
    <a
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
    >闽ICP备2026019197号-1</a>
  </footer>
</template>
